import Vue from 'vue'
import VueRouter from 'vue-router'
import VueRecource from 'vue-resource'
import App from './App.vue'
import clipboard from 'clipboard';

import router from './router' //引入路由

import axios from 'axios'
import qs from 'qs'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import './assets/css/iconfont/iconfont.css'
import './assets/css/commone.css'
import './assets/css/header.css'
import './assets/css/main.css'

import { vueBaberrage } from 'vue-baberrage'
Vue.use(vueBaberrage)

Vue.use(ElementUI);

Vue.use(VueRouter);
Vue.use(VueRecource);
Vue.prototype.clipboard = clipboard;

//const originalPush = VueRouter.prototype.push
//VueRouter.prototype.push = function push (location) {
//  return originalPush.call(this, location).catch(err => err)
//}

Vue.prototype.$qs = qs

axios.defaults.baseURL = "http://58.87.66.179";
axios.defaults.withCredentials=true
axios.defaults.crossDomain=true
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*'

Vue.prototype.axios = axios;

Vue.prototype.baseUrl = function () { return '' }
//Vue.prototype.baseUrl = function () { return 'https://marry.playhai.com' }
Vue.config.productionTip = false

Vue.http.interceptors.push((request, next) => {
  // modify request
  request.method = 'POST';
  if(!localStorage.token){
    localStorage.token = ''
    localStorage.status = 0
  }
  
  
  // console.log(request.body)
  next((response) => {
    return response;
  });
});
new Vue({
  router,
  VueRecource,
  render: h => h(App),
}).$mount('#app')
